const IconInfo = props => (
	<svg
		data-name="Calque 2"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M10.625 6C10.625 3.44568 8.55429 1.375 6 1.375C3.44568 1.375 1.375 3.44568 1.375 6C1.375 8.55429 3.44568 10.625 6 10.625C8.55429 10.625 10.625 8.55429 10.625 6ZM11.375 6C11.375 8.96851 8.96851 11.375 6 11.375C3.03147 11.375 0.625 8.96851 0.625 6C0.625 3.03147 3.03147 0.625 6 0.625C8.96851 0.625 11.375 3.03147 11.375 6Z"
			fill="currentColor"
		/>
		<path
			d="M6.00439 3.5L6.05566 3.50244C6.30778 3.52806 6.50439 3.74113 6.50439 4C6.50439 4.25887 6.30778 4.47194 6.05566 4.49756L6.00439 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.00439Z"
			fill="currentColor"
		/>
		<path
			d="M5.875 8.25V6.0498C5.875 5.98382 5.87505 5.93185 5.87402 5.88721C5.87393 5.88317 5.87315 5.87927 5.87305 5.87549C5.83892 5.87489 5.7993 5.875 5.75 5.875C5.54289 5.875 5.375 5.70711 5.375 5.5C5.375 5.29289 5.54289 5.125 5.75 5.125C5.8562 5.125 5.97726 5.12411 6.0791 5.13916C6.18113 5.15425 6.30312 5.19003 6.40967 5.28418L6.4541 5.32812L6.49268 5.375C6.57386 5.48559 6.60148 5.60612 6.61328 5.70264C6.62585 5.80552 6.625 5.9299 6.625 6.0498V8.25C6.625 8.45711 6.45711 8.625 6.25 8.625C6.04289 8.625 5.875 8.45711 5.875 8.25Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconInfo;
